'use strict';

// Override the normal readableDistance method so we can get greater accuracy
L.GeometryUtil = L.extend(L.GeometryUtil || {}, {
  readableArea: function (area, isMetric) {
    var areaStr;

    if (isMetric) {
      area = area.toFixed(3);
      areaStr = area + ' m&sup2;';
    } else {
      area *= 10.7639; // square feet per square meter
      area = area.toFixed(2);
      areaStr = area + ' ft&sup2';
    }

    return areaStr;
  },

  readableDistance: function (distance, isMetric) {
    var distanceStr;
    
    distance = parseFloat(distance);

    if (isMetric) {
      // show metres when distance is < 1km, then show km
      if (distance > 1000) {
        distance = (distance / 1000).toFixed(3);
        distanceStr = distance + ' km';
      } else {
        distance = distance.toFixed(2);
        distanceStr = distance + ' m';
      }
    } else {
      distance *= 1.09361; // convert meters to yards

      if (distance > 1760) {
        distance = (distance / 1760).toFixed(3);
        distanceStr = distance + ' miles';
      } else {
        distance = (distance * 3).toFixed(2);
        distanceStr = distance + ' ft';
      }
    }

    return distanceStr;
  }
});

module.exports = L.GeometryUtil;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/leaflet/GeometryUtil.js